import { DatePicker, Form, Select } from '@musinsa/pbo-core'
import type { FormInstance } from 'antd'
import type { SelectOptionType } from '@/components/content/SelectBoxTypes'
import { SHIPPER_TYPES } from '@/services/shipper/apis'
import { FilterCard, chipRange, chipSelect } from '../../dailyCloseShared/FilterCard'
import { clearShipperOnServiceType } from '../../dailyCloseShared/clearShipperOnServiceType'
import { FIELD_NAMES } from '../constants'
import type { DailyCloseFormValues } from '../filterToRequest'

interface Props {
  form: FormInstance
  initialValues: DailyCloseFormValues
  shipperOptions: SelectOptionType<string>[]
  warehouseOptions: SelectOptionType<string>[]
  canEditShipper: boolean
  /** 물류서비스타입을 고르면 화주를 비우는가 — 잠기지 않은 계정만(clearShipperOnServiceType). */
  clearsShipperOnServiceType: boolean
  onSearch: (values: DailyCloseFormValues) => void
  onReset: () => void
}

const SERVICE_TYPE_OPTIONS = SHIPPER_TYPES.map((type) => ({ value: type, label: type }))
const toChipOptions = (options: SelectOptionType<string>[]) => options.map((option) => ({ value: String(option.value), label: String(option.label) }))

export function DailyCloseFilter({ form, initialValues, shipperOptions, warehouseOptions, canEditShipper, clearsShipperOnServiceType, onSearch, onReset }: Readonly<Props>) {
  const shipperCode = Form.useWatch(FIELD_NAMES.shipperCode, form)
  const closeDateRange = Form.useWatch(FIELD_NAMES.closeDateRange, form)
  const warehouseName = Form.useWatch(FIELD_NAMES.warehouseName, form)
  const logisticsServiceType = Form.useWatch(FIELD_NAMES.logisticsServiceType, form)

  return (
    <Form form={form} initialValues={initialValues} onFinish={(values) => onSearch(values as DailyCloseFormValues)}>
      <FilterCard
        onReset={onReset}
        fields={[
          {
            key: FIELD_NAMES.shipperCode,
            label: '화주',
            chip: chipSelect(toChipOptions(shipperOptions), shipperCode),
            control: (
              <Form.Item name={FIELD_NAMES.shipperCode} noStyle>
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  options={shipperOptions}
                  disabled={!canEditShipper}
                  placeholder="화주 선택"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            ),
          },
          {
            key: FIELD_NAMES.closeDateRange,
            label: '마감일자',
            required: true,
            chip: chipRange(closeDateRange),
            control: (
              <Form.Item name={FIELD_NAMES.closeDateRange} noStyle>
                <DatePicker.RangePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
              </Form.Item>
            ),
          },
          {
            key: FIELD_NAMES.warehouseName,
            label: '주문센터',
            chip: chipSelect(toChipOptions(warehouseOptions), warehouseName),
            control: (
              <Form.Item name={FIELD_NAMES.warehouseName} noStyle>
                <Select allowClear showSearch optionFilterProp="label" options={warehouseOptions} placeholder="전체" style={{ width: '100%' }} />
              </Form.Item>
            ),
          },
          {
            key: FIELD_NAMES.logisticsServiceType,
            label: '물류서비스타입',
            chip: chipSelect(SERVICE_TYPE_OPTIONS, logisticsServiceType),
            control: (
              <Form.Item name={FIELD_NAMES.logisticsServiceType} noStyle>
                <Select
                  allowClear
                  options={SERVICE_TYPE_OPTIONS}
                  placeholder="전체"
                  style={{ width: '100%' }}
                  onChange={(value?: string | null) => clearShipperOnServiceType(form, FIELD_NAMES.shipperCode, clearsShipperOnServiceType, value)}
                />
              </Form.Item>
            ),
          },
        ]}
      />
    </Form>
  )
}
